<ng-template let-modal #chatBot>
    <div class="chatbot-container">
        <div class="chatbot-header">
            <h2 class="title">{{ title }}</h2>
            <button class="rounded-circle chatbot-refresh" (click)="newConversation()">
                <fa-icon [icon]="['fal', 'refresh']" size="lg"></fa-icon>
            </button>
            <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
        </div>
        <div #chatbotBody class="chatbot-body">
            @for (message of chatService.messages; track $index) {
                <app-chatbot-message [message]="message"></app-chatbot-message>
            }
            @if (chatService.messages.length === 1) {
                <app-example-questions (exampleQuestionClicked)="sendExampleMessage($event)">
                </app-example-questions>
            }
            @if (displayLoadingAnim) {
                <app-loading-animation></app-loading-animation>
            }
            @if (showAiDisclosure) {
                <shd-infobox class="chatbot-ai-disclosure" (dismissed)="dismissAiDisclosure()"
                             [isDismissable]="true"
                             [type]="'info'"
                             [headerText]="'CHATBOT_AI_DISCLOSURE_HEADER' | translate"
                             [bodyText]="'CHATBOT_AI_DISCLOSURE' | translate" />
            }
        </div>
        <form class="chatbot-footer" (ngSubmit)="sendMessage()">
            <input type="text" id="chatBotInput" name="chatBotInput" autocomplete="off"
                   [(ngModel)]="textInput" class="form-control" placeholder="Nachricht eingeben">
            <button class="rounded-circle chatbot-send" type="submit">
                <fa-icon [icon]="['fal', 'paper-plane']" size="lg"></fa-icon>
            </button>
        </form>
    </div>
</ng-template>
